
export default class artistsPage {
   constructor(){


      $('.artists-page--list > a').draggable({
      });

   }
}